import { Avatar, Grid, Typography } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import useStyles from './Style'

interface IProps {
  content: {
    img: string
    name: string
    age: number
    description: string
    secondaryText: string
  }
  zenMode: boolean
}

const Card: React.FC<IProps> = ({ content, zenMode }) => {
  const { name, age, description, secondaryText } = content
  const { classes } = useStyles()

  return (
    <Grid
      className={clsx(
        classes.rootContainer,
        zenMode && classes.rootZenContainer
      )}
    >
      <Grid container spacing={3} className={classes.cardContent}>
        <Grid item md={zenMode ? 0 : 2} sm={12}>
          <Grid container spacing={5} alignItems="center ">
            <Grid item sx={{ display: zenMode ? 'none' : 'flex' }}>
              <Avatar
                className={classes.imgContainer}
                alt={content.name}
                src={content.img}
              />
            </Grid>

            <Grid
              item
              sx={{ display: { md: 'none', sm: 'block', xs: 'block' } }}
            >
              <Typography className={classes.name}>{name}</Typography>
              <Typography className={classes.age}>
                {age === -1 ? 'Parent' : 'AGE ' + age}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={0}
          sx={{ display: { md: 'flex', sm: 'none', xs: 'none' } }}
        ></Grid>
        <Grid item md={9} className={classes.cardTextContainer}>
          <Grid sx={{ display: { md: 'block', sm: 'none', xs: 'none' } }}>
            <Typography className={classes.name}>{name}</Typography>
            <Typography className={classes.age}>
              {age === -1 ? 'Parent' : 'AGE ' + age}
            </Typography>
          </Grid>

          <Grid>
            <Typography className={classes.description}>
              {description}
            </Typography>
            <Typography className={classes.secondaryText}>
              {secondaryText}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Card
